import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.css';
import React from 'react';
import { render } from 'react-dom';
import { AuthProvider } from 'react-oidc-context';
import { Provider } from 'react-redux';
import { browserHistory, Router } from 'react-router';
import { GetAuthenticationServiceInfo } from './actions/LoginActions';
import { loadEntrepreneurs, loadSaksbehandlere } from './actions/selskaperActions';
import UserProvider from './containers/User/UserProvider';
import GeonorgeProvider from './context/Geonorge/GeonorgeProvider';
import './css/bootstrap-theme-bym.css';
import './css/index.css';
import { oidcConfig } from './oidcConfig';
import { getRoutes } from './routes';
import store from './store/store';
import { UserIsBymAdmin, UserIsServicedesk, UserIsServicedeskAdmin } from './utils/cookieHandler';

axios.defaults.headers['X-Bymelding-Client'] = 'BymeldingClient_1.0:1.0';
store.dispatch(GetAuthenticationServiceInfo()).then(() => {
    store.dispatch(loadEntrepreneurs());
    if (UserIsServicedeskAdmin() || UserIsServicedesk() || UserIsBymAdmin()) {
        store.dispatch(loadSaksbehandlere());
    }
});

const app = document.getElementById('app');
render(
    <AuthProvider {...oidcConfig}>
        <UserProvider>
            <GeonorgeProvider>
                <Provider store={store}>
                    <Router history={browserHistory}>{getRoutes(store)}</Router>
                </Provider>
            </GeonorgeProvider>
        </UserProvider>
    </AuthProvider>,
    app
);
